/* src/app/modules/advisor/advisor-list.component.css */
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
th.mat-mdc-header-cell,
td.mat-mdc-cell {
  padding: 8px 12px;
  text-align: left;
}
th.mat-mdc-header-cell {
  font-weight: 600;
  background: #f5f5f5;
}
tr.mat-mdc-row:nth-child(even) {
  background: #fafafa;
}
.center {
  text-align: center;
}
.right {
  text-align: right;
}
.cell-ellipsis {
  display: inline-block;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=advisor-list.component.css.map */
